export const Contact = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
<path d="M21 8V2" stroke="currentColor" stroke-width="2"/>
<path d="M11 8V2" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="14" r="3" stroke="currentColor" stroke-width="2"/>
<path d="M21 24V22C21 20.8954 20.1046 20 19 20H13C11.8954 20 11 20.8954 11 22V24" stroke="currentColor" stroke-width="2"/>
</svg>`;
